module.exports = __webpack_public_path__ + "static/media/paper_video.7ff2e375.jpg";